import { useReportFormSubmit } from "./useReportFormSubmit";

type ReportFormLoaderProps = {
  reportId: number;
  closeModal: () => void;
};

export const useReportFormLoader = ({
  reportId,
  closeModal,
}: ReportFormLoaderProps) => {
  const {
    reportForm,
    previewUrl,
    handleFileChange,
    handleSubmit,
    isSubmitting,
  } = useReportFormSubmit({ reportId, onSuccess: closeModal });

  return {
    handleUpdateReport: handleSubmit,
    reportForm,
    isLoading: isSubmitting,
    previewUrl,
    handleFileChange,
  };
};
